/**
 * Event bus which forwards server-side organization events.
 *
 * This is a singleton so every import gets the same instance.
 */
export const ORGANIZATION_EVENTS_RECONNECTED_EVENT =
    'organization-events-reconnected';
export const ORGANIZATION_EVENTS_CONNECTION_OPENED_EVENT =
    'organization-events-connection-opened';
export const ORGANIZATION_EVENTS_CONNECTION_CLOSED_EVENT =
    'organization-events-connection-closed';

export type OrganizationEventsReconnectedDetail = {
    readonly organizationId: string;
};

export type OrganizationEventsConnectionDetail = {
    readonly organizationId: string;
};

export type OrganizationEventBusDetail<T> = {
    readonly organizationId: string | null;
    readonly event: T;
};

export const organizationEventBus = new EventTarget();

if (
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname)
) {
    (window as unknown as Record<string, unknown>)[
        '__phoebeOrganizationEventBusForTests__'
    ] = organizationEventBus;
}
